import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from './Button';
import colors from './constants/colors';
import SectionWrap from './SectionWrap';
import SVGIcon, { RIGHT_FACING_ARROW } from './SVGIcon';
import Loader from './Loader';
import Spinner from './Spinner';

const StyledFooter = styled.footer`
  align-items: center;
  background: ${colors.white};
  box-shadow: inset 0 1px 0 0 rgba(47, 48, 52, 0.1); // charcoal
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  justify-content: flex-end;
  z-index: 1;
  padding: 16px;
`;

const Footer = ({
  hasTakeToApp,
  hasTransparentBackground,
  icon,
  isLoading,
  onClickNext,
  onClickTakeToApp,
  text,
}) => (
  <StyledFooter>
    <SectionWrap>
      {hasTakeToApp ? (
        <Button data-test-id="signup-thanks-button" onClick={onClickTakeToApp}>
          {text}
          <SVGIcon icon={RIGHT_FACING_ARROW} />
        </Button>
      ) : (
        <Button
          data-test-id="next-button"
          disabled={isLoading}
          aria-label={text}
          role="button"
          onClick={onClickNext}
          styleType={hasTransparentBackground ? 'subtle' : 'primary'}
          type="submit"
        >
          {text}
          {icon && <SVGIcon icon={icon} />}
          {isLoading && (
            <Loader>
              <Spinner />
            </Loader>
          )}
        </Button>
      )}
    </SectionWrap>
  </StyledFooter>
);

Footer.propTypes = {
  hasTakeToApp: PropTypes.bool,
  hasTransparentBackground: PropTypes.bool,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  onClickNext: PropTypes.func,
  onClickTakeToApp: PropTypes.func,
  text: PropTypes.string,
};

Footer.defaultProps = {
  hasTakeToApp: false,
  hasTransparentBackground: false,
  icon: '',
  isLoading: false,
  step: null,
  text: 'Next',
};

export default Footer;
